import React from 'react';
import { T } from 'shared/helper/translate';
var RubriqSearchResultsCount = function RubriqSearchResultsCount(_ref) {
  var count = _ref.count,
    term = _ref.term,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading;
  return /*#__PURE__*/React.createElement("span", {
    className: "text-muted"
  }, loading ? /*#__PURE__*/React.createElement(T, {
    source: "rubriq.searching",
    params: {
      term: term
    }
  }) : /*#__PURE__*/React.createElement(T, {
    source: "rubriq.search-results-count",
    params: {
      count: count,
      term: term
    }
  }));
};
export default RubriqSearchResultsCount;